<div class="container-fluid glb-popup">
  <div class="d-flex flex-wrap align-items-center justify-content-between">
    <h2> {{formTitle}}</h2>
    <div class="grLink">
      <a class="p-button p-button-outlined p-button-info" (click)="openReviewDialog()">Guest Review</a>
    </div>
  </div>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="title" id="title" type="text" pInputText>
            <label for="title">Title</label>
            @for (validation of validationMessages.title; track validation) {
              <span>
                @if (form1.get('title').hasError(validation.type) && (form1.get('title').dirty || form1.get('title').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>


        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="reservationId" id="reservationId" type="number" pInputText>
            <label for="reservationId">Reservation #</label>
            @for (validation of validationMessages.reservationId; track validation) {
              <span>
                @if (form1.get('reservationId').hasError(validation.type) && (form1.get('reservationId').dirty || form1.get('reservationId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="properties" formControlName="shortTermRentalId" optionLabel="propertyCode"
            optionValue="shortTermRentalId" placeholder="Properties"></p-dropdown>
            <label for="shortTermRentalId">Properties</label>
            @for (validation of validationMessages.shortTermRentalId; track validation) {
              <span>
                @if (form1.get('shortTermRentalId').hasError(validation.type) && (form1.get('shortTermRentalId').dirty || form1.get('shortTermRentalId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <p-calendar formControlName="receiveDate" inputId="receiveDate" appendTo="body">
            </p-calendar>
            <label for="receiveDate">Receive Date</label>
            @for (validation of validationMessages.receiveDate; track validation) {
              <span>
                @if (form1.get('receiveDate').hasError(validation.type) && (form1.get('receiveDate').dirty || form1.get('receiveDate').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="reservationistRank" id="reservationistRank" type="number" pInputText>
            <label for="reservationistRank">Reservationist Rank</label>
            @for (validation of validationMessages.reservationistRank; track validation) {
              <span>
                @if (form1.get('reservationistRank').hasError(validation.type) && (form1.get('reservationistRank').dirty || form1.get('reservationistRank').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="reservationistFeedbackDesc" id="reservationistFeedbackDesc" [rows]="2" pInputTextarea></textarea>
            <label for="reservationistFeedbackDesc">Reservationist Feedback Desc</label>
            @for (validation of validationMessages.reservationistFeedbackDesc; track validation) {
              <span>
                @if (form1.get('reservationistFeedbackDesc').hasError(validation.type) && (form1.get('reservationistFeedbackDesc').dirty || form1.get('reservationistFeedbackDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="vehicleReservationProcessRank" id="vehicleReservationProcessRank" type="number" pInputText>
            <label for="vehicleReservationProcessRank">Vehicle Reservation Process Rank</label>
            @for (validation of validationMessages.vehicleReservationProcessRank; track validation) {
              <span>
                @if (form1.get('vehicleReservationProcessRank').hasError(validation.type) && (form1.get('vehicleReservationProcessRank').dirty || form1.get('vehicleReservationProcessRank').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="vehicleRentalCompanyRank" id="vehicleRentalCompanyRank" type="number" pInputText>
            <label for="vehicleRentalCompanyRank">Vehicle Rental Company Rank</label>
            @for (validation of validationMessages.vehicleRentalCompanyRank; track validation) {
              <span>
                @if (form1.get('vehicleRentalCompanyRank').hasError(validation.type) && (form1.get('vehicleRentalCompanyRank').dirty || form1.get('vehicleRentalCompanyRank').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="vehicleQualityRank" id="vehicleQualityRank" type="number" pInputText>
            <label for="vehicleQualityRank">Vehicle Quality Rank</label>
            @for (validation of validationMessages.vehicleQualityRank; track validation) {
              <span>
                @if (form1.get('vehicleQualityRank').hasError(validation.type) && (form1.get('vehicleQualityRank').dirty || form1.get('vehicleQualityRank').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="vehicleFeedbackDesc" id="vehicleFeedbackDesc" [rows]="2" pInputTextarea></textarea>
            <label for="vehicleFeedbackDesc">Vehicle Feedback Desc</label>
            @for (validation of validationMessages.vehicleFeedbackDesc; track validation) {
              <span>
                @if (form1.get('vehicleFeedbackDesc').hasError(validation.type) && (form1.get('vehicleFeedbackDesc').dirty || form1.get('vehicleFeedbackDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="preArrivalInfoRank" id="preArrivalInfoRank" type="number" pInputText>
            <label for="preArrivalInfoRank">Pre Arrival Info Rank</label>
            @for (validation of validationMessages.preArrivalInfoRank; track validation) {
              <span>
                @if (form1.get('preArrivalInfoRank').hasError(validation.type) && (form1.get('preArrivalInfoRank').dirty || form1.get('preArrivalInfoRank').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="preArrivalFeedbackDesc" id="preArrivalFeedbackDesc" [rows]="2" pInputTextarea></textarea>
            <label for="preArrivalFeedbackDesc">Pre Arrival Feedback Desc</label>
            @for (validation of validationMessages.preArrivalFeedbackDesc; track validation) {
              <span>
                @if (form1.get('preArrivalFeedbackDesc').hasError(validation.type) && (form1.get('preArrivalFeedbackDesc').dirty || form1.get('preArrivalFeedbackDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="checkinProcessRank" id="checkinProcessRank" type="number" pInputText>
            <label for="checkinProcessRank">Checkin Process Rank</label>
            @for (validation of validationMessages.checkinProcessRank; track validation) {
              <span>
                @if (form1.get('checkinProcessRank').hasError(validation.type) && (form1.get('checkinProcessRank').dirty || form1.get('checkinProcessRank').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="checkinFeedbackDesc" id="checkinFeedbackDesc" [rows]="2" pInputTextarea></textarea>
            <label for="checkinFeedbackDesc">Checkin Feedback Desc</label>
            @for (validation of validationMessages.checkinFeedbackDesc; track validation) {
              <span>
                @if (form1.get('checkinFeedbackDesc').hasError(validation.type) && (form1.get('checkinFeedbackDesc').dirty || form1.get('checkinFeedbackDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="constructiveFeedbackDesc" id="constructiveFeedbackDesc" [rows]="2" pInputTextarea></textarea>
            <label for="constructiveFeedbackDesc">Constructive Feedback Desc</label>
            @for (validation of validationMessages.constructiveFeedbackDesc; track validation) {
              <span>
                @if (form1.get('constructiveFeedbackDesc').hasError(validation.type) && (form1.get('constructiveFeedbackDesc').dirty || form1.get('constructiveFeedbackDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="propertyPresentationRank" id="propertyPresentationRank" type="number" pInputText>
            <label for="propertyPresentationRank">Property Presentation Rank</label>
            @for (validation of validationMessages.propertyPresentationRank; track validation) {
              <span>
                @if (form1.get('propertyPresentationRank').hasError(validation.type) && (form1.get('propertyPresentationRank').dirty || form1.get('propertyPresentationRank').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="propertyMaintenanceRank" id="propertyMaintenanceRank" type="number" pInputText>
            <label for="propertyMaintenanceRank">Property Maintenance Rank</label>
            @for (validation of validationMessages.propertyMaintenanceRank; track validation) {
              <span>
                @if (form1.get('propertyMaintenanceRank').hasError(validation.type) && (form1.get('propertyMaintenanceRank').dirty || form1.get('propertyMaintenanceRank').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="propertyFeedbackDesc" id="propertyFeedbackDesc" [rows]="2" pInputTextarea></textarea>
            <label for="propertyFeedbackDesc">Property Feedback Desc</label>
            @for (validation of validationMessages.propertyFeedbackDesc; track validation) {
              <span>
                @if (form1.get('propertyFeedbackDesc').hasError(validation.type) && (form1.get('propertyFeedbackDesc').dirty || form1.get('propertyFeedbackDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="guestServicesQualityRank" id="guestServicesQualityRank" type="number" pInputText>
            <label for="guestServicesQualityRank">Guest Services Quality Rank</label>
            @for (validation of validationMessages.guestServicesQualityRank; track validation) {
              <span>
                @if (form1.get('guestServicesQualityRank').hasError(validation.type) && (form1.get('guestServicesQualityRank').dirty || form1.get('guestServicesQualityRank').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="overallExperienceRank" id="overallExperienceRank" type="number" pInputText>
            <label for="overallExperienceRank">Overall Experience Rank</label>
            @for (validation of validationMessages.overallExperienceRank; track validation) {
              <span>
                @if (form1.get('overallExperienceRank').hasError(validation.type) && (form1.get('overallExperienceRank').dirty || form1.get('overallExperienceRank').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="overallExperienceFeedbackDesc" id="overallExperienceFeedbackDesc" [rows]="2" pInputTextarea></textarea>
            <label for="overallExperienceFeedbackDesc">Overall Experience Feedback Desc</label>
            @for (validation of validationMessages.overallExperienceFeedbackDesc; track validation) {
              <span>
                @if (form1.get('overallExperienceFeedbackDesc').hasError(validation.type) && (form1.get('overallExperienceFeedbackDesc').dirty || form1.get('overallExperienceFeedbackDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="guestName" id="guestName" type="text" pInputText>
            <label for="guestName">Guest Name</label>
            @for (validation of validationMessages.guestName; track validation) {
              <span>
                @if (form1.get('guestName').hasError(validation.type) && (form1.get('guestName').dirty || form1.get('guestName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="guestEmail" id="guestEmail" type="text" pInputText>
            <label for="guestEmail">Guest Email</label>
            @for (validation of validationMessages.guestEmail; track validation) {
              <span>
                @if (form1.get('guestEmail').hasError(validation.type) && (form1.get('guestEmail').dirty || form1.get('guestEmail').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <!-- <p-inputMask formControlName="guestPhone" id="guestPhone" mask="(999) 999-9999" type="text">
          </p-inputMask> -->
          <input formControlName="guestPhone" id="guestPhone" type="text" pInputText>
          <label for="guestPhone">Guest Phone</label>
          @for (validation of validationMessages.guestPhone; track validation) {
            <span>
              @if (form1.get('guestPhone').hasError(validation.type) && (form1.get('guestPhone').dirty || form1.get('guestPhone').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12">
        <span class="p-float-label w-100 mb-3">
          <p-calendar formControlName="guestFollowupDate" inputId="guestFollowupDate" appendTo="body">
          </p-calendar>
          <label for="guestFollowupDate">Guest Followup Date</label>
          @for (validation of validationMessages.guestFollowupDate; track validation) {
            <span>
              @if (form1.get('guestFollowupDate').hasError(validation.type) && (form1.get('guestFollowupDate').dirty || form1.get('guestFollowupDate').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>


      <div class="col-lg-12">
        <h6 for="guestFollowupRequest">Guest Followup Request</h6>
        <div class="flex align-items-center">
          <p-checkbox [formControl]="form1.controls['guestFollowupRequest']" inputId="guestFollowupRequest" [binary]="true"></p-checkbox>
          <span class="guestExitSurvey-nm">Is Guest Followup Request?</span>
        </div>
        @for (validation of validationMessages.guestFollowupRequest; track validation) {
          <span>
            @if (form1.get('guestFollowupRequest').hasError(validation.type) && (form1.get('guestFollowupRequest').dirty || form1.get('guestFollowupRequest').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </div>


    </div>
  </div>
  <hr>
    <div class="row m-0">
      <div class="col-lg-12">
        <div class="btn-group">
          <div class="button-group">
            @if (guestExitSurveyId) {
              <button pButton class="btn-delete p-button-outlined p-button-danger"
              (click)="onFormDelete()">Delete</button>
            }
          </div>

          <div class="button-group">
            <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
            @if (!guestExitSurveyId) {
              <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
            }

            @if (guestExitSurveyId) {
              <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update</button>
            }
          </div>
        </div>
      </div>
    </div>

  </div>